"use client";

import React, { useCallback, useEffect, useState } from "react";
import Modal from "../ui/modal/Modal";
import DoctormLogo from "@/assets/logos/doctor_m_logo.svg?react";
import { fittingBoxApiKey } from "@/runtimeConfig/public";

interface VtoModalProps {
  isOpen: boolean;
  frameId: { ean: string; sku: string };
  toggle: () => void;
}

const VtoModalContent = ({ isOpen, frameId }: Omit<VtoModalProps, "toggle">) => {
  const [validFrameId, setValidFrameId] = React.useState<string | null>(frameId.ean);

  console.log({ fittingBoxApiKey });

  const initializeFitMix = useCallback(
    (validFrameId?: string | null) => {
      if (typeof window.FitMix !== "undefined") {
        const params = {
          apiKey: fittingBoxApiKey,
          frame: validFrameId || frameId.ean || frameId.sku,
          onLiveStatus: (data: { userHasGlasses: boolean }) => {
            if (data.userHasGlasses) {
              displayUI();
            }
          },
          onStopVto: hideUI,
        };

        try {
          const instance = window.FitMix.createWidget("fitmix-container", params, () => {
            instance.startVto("live");
          });
        } catch (error) {
          console.error("Failed to create FitMix widget:", error);
        }
      } else {
        console.error("FitMix is not defined");
      }
    },
    [frameId.ean, frameId.sku],
  );

  useEffect(() => {
    const fetchValidFrameId = async () => {
      try {
        const ids = Object.values(frameId).join(",");
        const validFrame = await fetch(
          `https://product-api.fittingbox.com/glasses-metadata/availability?apiKey=${fittingBoxApiKey}&uidList=${ids}`,
        );
        if (validFrame.ok) {
          const data = await validFrame.json();
          const frame =
            Array.isArray(data) &&
            data?.find((frame: { uid: string; available: boolean }) => frame?.available);
          setValidFrameId(frame?.uid || null);
        }
      } catch (error) {
        console.error("Failed to fetch valid frame ID:", error);
      }
    };

    if (isOpen) {
      fetchValidFrameId().then(() => {
        const script = document.createElement("script");
        script.src = "//vto-advanced-integration-api.fittingbox.com/index.js";
        script.async = true;
        script.onload = () => initializeFitMix(validFrameId);
        document.body.appendChild(script);

        return () => {
          document.body.removeChild(script);
        };
      });
    }
  }, [initializeFitMix, isOpen, frameId, validFrameId]);

  const displayUI = () => {
    console.info("Displaying the UI");
  };

  const hideUI = () => {
    console.info("Hiding the UI");
  };
  return (
    <div className="sm:w-[30rem] lg:w-[40rem]">
      <div id="fitmix-container" style={{ width: "100%", height: "500px" }}></div>
    </div>
  );
};

const VtoModal = ({ frameId, isOpen, toggle }: VtoModalProps) => {
  return (
    <Modal
      children={<VtoModalContent frameId={frameId} isOpen={isOpen} />}
      isOpen={isOpen}
      onClose={toggle}
      title={<DoctormLogo />}
    />
  );
};

export default VtoModal;
